import React from 'react';

interface SVGTikTokIconProps {
    className?: string;
    /** Renders at native 27×30 aspect ratio; `size` is the width in px. */
    size?: number;
}

const VIEWBOX_W = 27;
const VIEWBOX_H = 30;

/**
 * TikTok mark — Globe Thrivers App 2 (Figma node 16193:14461).
 */
const SVGTikTokIcon: React.FC<SVGTikTokIconProps> = ({ className, size = 27 }) => {
    const width = size;
    const height = Math.round((size * VIEWBOX_H) / VIEWBOX_W);

    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden
        >
            <path
                d="M20.0089 10.8024C21.9788 12.183 24.3922 12.9952 26.9986 12.9952V8.07834C26.5053 8.07852 26.0133 8.02804 25.5307 7.92772V11.798C22.9245 11.798 20.5115 10.9859 18.5411 9.60544V19.6395C18.5411 24.6591 14.3903 28.728 9.27038 28.728C7.36003 28.728 5.58436 28.1618 4.10938 27.1907C5.79287 28.8783 8.1406 29.9251 10.7379 29.9251C15.8582 29.9251 20.0091 25.8562 20.0091 20.8364V10.8024H20.0089ZM21.8198 5.84189C20.813 4.76365 20.1519 3.3702 20.0089 1.82964V1.19727H18.6179C18.968 3.15523 20.1625 4.82799 21.8198 5.84189ZM7.34769 23.3389C6.78516 22.616 6.4811 21.7314 6.48253 20.822C6.48253 18.5263 8.38107 16.6649 10.7234 16.6649C11.1599 16.6646 11.5938 16.7303 12.0098 16.8596V11.8328C11.5236 11.7675 11.033 11.7397 10.5425 11.7499V15.6625C10.1263 15.5332 9.69217 15.4675 9.25551 15.4679C6.91326 15.4679 5.01482 17.3291 5.01482 19.6251C5.01482 21.2486 5.96373 22.6542 7.34769 23.3389Z"
                fill="#FF004F"
            />
            <path
                d="M18.5427 9.60533C20.5131 10.9857 22.9259 11.7979 25.5323 11.7979V7.92761C24.0775 7.62378 22.7896 6.87854 21.8213 5.84189C20.1638 4.82789 18.9696 3.15513 18.6194 1.19727H14.9657V20.8362C14.9574 23.1257 13.0621 24.9795 10.7248 24.9795C9.34758 24.9795 8.12393 24.336 7.34905 23.3388C5.9653 22.6542 5.0163 21.2485 5.0163 19.6252C5.0163 17.3294 6.91473 15.468 9.25698 15.468C9.70575 15.468 10.1383 15.5364 10.544 15.6626V11.75C5.514 11.8519 1.46875 15.881 1.46875 20.8363C1.46875 23.31 2.47608 25.5524 4.11106 27.1909C5.58604 28.1618 7.36161 28.7282 9.27207 28.7282C14.392 28.7282 18.5428 24.659 18.5428 19.6395L18.5427 9.60533Z"
                fill="#252528"
            />
            <path
                d="M25.5313 7.92724V6.88097C24.2194 6.88283 22.9334 6.52266 21.8203 5.84162C22.8056 6.89908 24.103 7.62831 25.5313 7.92745M18.6184 1.1969C18.585 1.00982 18.5594 0.821491 18.5416 0.632379V0H13.4966V19.6391C13.4886 21.9284 11.5933 23.7822 9.25594 23.7822C8.5933 23.7832 7.93973 23.6313 7.34801 23.3388C8.12289 24.3357 9.34654 24.9791 10.7237 24.9791C13.0609 24.9791 14.9564 23.1256 14.9646 20.836V1.197L18.6184 1.1969ZM10.5433 11.7497V10.6356C10.1217 10.5792 9.69672 10.5509 9.27123 10.551C4.15072 10.551 0 14.62 0 19.6391C0 22.7859 1.63129 25.5592 4.11022 27.1904C2.47525 25.552 1.46791 23.3095 1.46791 20.8359C1.46791 15.8808 5.51306 11.8516 10.5433 11.7497Z"
                fill="#00F2EA"
            />
        </svg>
    );
};

export default SVGTikTokIcon;
